import React from 'react';

export const LandPage = React.lazy(() =>
  import('./containers/public/index').then((comp) => {
    return {
      default: comp.Public,
    };
  }),
);


export const OuvidoriaPage = React.lazy(() =>
  import('./containers/public/ouvidoria').then((comp) => {
    return {
      default: comp.Ouvidoria,
    };
  }),
);

export const ResetPage = React.lazy(() =>
  import('./containers/public/reset').then((comp) => {
    return {
      default: comp.Reset,
    };
  }),
);

export const GenericNotFound = React.lazy(() =>
  import('@pages/GenericNotFound').then((comp) => {
    return {
      default: comp.GenericNotFound,
    };
  }),
);

export const ActiveAccount = React.lazy(() =>
  import('@pages/ActiveAccount').then((comp) => {
    return {
      default: comp.ActiveAccount,
    };
  }),
);

// Private
export const DashboardDefaults = React.lazy(() =>
  import('@pages/private/DashboardDefaults').then((comp) => {
    return {
      default: comp.DashboardDefaults,
    };
  }),
);

// Private
export const DashboardUsers = React.lazy(() =>
  import('@pages/private/DashboardUsers').then((comp) => {
    return {
      default: comp.DashboardUsers,
    };
  }),
);

// Private
export const DashboardAdmins = React.lazy(() =>
  import('@pages/private/DashboardAdminsNew').then((comp) => {
    return {
      default: comp.DashboardAdminsNew,
    };
  }),
);

//Private
export const OuvidoriaAdm = React.lazy(() =>
  import('@pages/private/DashboardAdmins/ouvidoria-adm').then((comp) => {
    return {
      default: comp.OuvidoriaAdm,
    };
  })
);


// Private
export const DashboardOperators = React.lazy(() =>
  import('@pages/private/DashboardOperators').then((comp) => {
    return {
      default: comp.DashboardOperators,
    };
  }),
);

// Private
export const Dashboard = React.lazy(() =>
  import('@pages/private/DashboardDefaults').then((comp) => {
    return {
      default: comp.DashboardDefaults,
    };
  }),
);

// export const DashboardFinance = React.lazy(() =>
//   import('@pages/private/DashboardFinance').then((comp) => {
//     return {
//       default: comp.DashboardFinance,
//     };
//   }),
// );

// export const DashboardManager = React.lazy(() =>
//   import('@pages/private/DashboardManager').then((comp) => {
//     return {
//       default: comp.DashboardManager,
//     };
//   }),
// );

// export const Properties = React.lazy(() =>
//   import('@pages/private/Properties').then((comp) => {
//     return {
//       default: comp.Properties,
//     };
//   }),
// );

// export const AddProperties = React.lazy(() =>
//   import('@pages/private/Properties/add').then((comp) => {
//     return {
//       default: comp.Add,
//     };
//   }),
// );

// export const Campaign = React.lazy(() =>
//   import('@pages/private/Campaign').then((comp) => {
//     return {
//       default: comp.Campaign,
//     };
//   }),
// );

// export const CampaignItems = React.lazy(() =>
//   import('@pages/private/Campaign/CampaignItems').then((comp) => {
//     return {
//       default: comp.CampaignItems,
//     };
//   }),
// );

// export const Processes = React.lazy(() =>
//   import('@pages/private/Processes').then((comp) => {
//     return {
//       default: comp.Processes,
//     };
//   }),
// );

// export const Contracts = React.lazy(() =>
//   import('@pages/private/Contracts').then((comp) => {
//     return {
//       default: comp.Contracts,
//     };
//   }),
// );

// export const NewContracts = React.lazy(() =>
//   import('@pages/private/Contracts/NewContracts').then((comp) => {
//     return {
//       default: comp.NewContracts,
//     };
//   }),
// );

// export const supplyOrderAuth = React.lazy(() =>
//   import('@pages/private/supplyOrderAuth').then((comp) => {
//     return {
//       default: comp.supplyOrderAuth,
//     };
//   }),
// );

